import DocsComponent from './DocsComponent';

export default DocsComponent;
